import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { TEST_IDS } from "@/constants/testIds";

const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_ecf724c0-e7a0-4855-8934-70820d6dc685/artifacts/da2d482aee03c0e9_DV%20logo.png";

export default function Footer() {
  const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Our Services", path: "/services" },
    { label: "Our Clients", path: "/clients" },
    { label: "Get Quote", path: "/quote" },
  ];

  const services = [
    "Mobile App Development",
    "Custom Software Engineering",
    "Web Development",
    "Social Media Marketing",
    "Business Development",
    "Product Marketing",
  ];

  return (
    <footer data-testid={TEST_IDS.footer.section} className="bg-[#0A0E1A] border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img src={LOGO_URL} alt="Devkuba Ventures" className="h-12 w-auto mb-4" />
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Next-Gen IT Engineering & Growth Marketing Agency building scalable digital products for ambitious businesses.
            </p>
            <Link to="/quote">
              <Button
                data-testid={TEST_IDS.footer.ctaBtn}
                className="bg-gradient-to-r from-[#00F2FE] via-[#0EA5E9] to-[#3B82F6] text-[#060913] font-semibold hover:opacity-90 gap-2"
              >
                Start Your Project <ArrowRight className="h-4 w-4" />
              </Button>
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-slate-100 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-slate-400 hover:text-[#00F2FE] text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-slate-100 mb-4">Services</h4>
            <ul className="space-y-2.5">
              {services.map((svc) => (
                <li key={svc}>
                  <span className="text-slate-400 text-sm">{svc}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-slate-100 mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#0EA5E9] mt-1 shrink-0" />
                <p className="text-slate-400 text-sm leading-relaxed">
                  SCO - 101, Suramya Heights, Eklingji Road, Sanand, Ahmedabad, Gujarat, India - 382110
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#0EA5E9] shrink-0" />
                <span className="text-slate-400 text-sm">team@devkubaventures.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#0EA5E9] shrink-0" />
                <span className="text-slate-400 text-sm">+91 76210 35623</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-white/[0.06]" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Devkuba Ventures Private Limited. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-slate-500 text-xs">Privacy Policy</span>
            <span className="text-slate-500 text-xs">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
